export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        tv: {
          display: 'TV',
          mediaType: 'mp4',
          sortOrder: 1
        },
        radio: {
          display: 'Radio',
          mediaType: 'mp3',
          sortOrder: 2
        },
        display: {
          display: 'Display',
          mediaType: 'pdf',
          sortOrder: 3
        },
        online_video: {
          display: 'Online Video',
          mediaType: 'mp4',
          sortOrder: 4
        },
        social_post: {
          display: 'Social Post',
          mediaType: 'mp4',
          sortOrder: 5
        }
      }
    }
  ]
}
